<template>
    <div>
        <CreateAnimal />
    </div>
</template>

<script>
import CreateAnimal from '../../components/animal/CreateAnimal.vue';
export default {
    components: {
        CreateAnimal
    },
    name: 'AnimalCreate'
}
</script>